"use client";
import "../../../chunk-MMUBH76A.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { CpslIcon, CpslInfoBox, CpslText } from "@getpara/react-components";
import { InfoBoxContent, InfoBoxHeader, StepContainer } from "../common.js";
import { useEffect, useRef, useState } from "react";
import { Waiting } from "../Waiting/Waiting.js";
import { useThemeStore } from "../../stores/index.js";
const AwaitingWalletCreationStep = () => {
  const hideWallets = useThemeStore((state) => state.hideWallets);
  const [showInfoBox, setShowInfoBox] = useState(false);
  const showInfoBoxTimeout = useRef();
  useEffect(() => {
    if (typeof window !== "undefined") {
      showInfoBoxTimeout.current = window.setTimeout(() => {
        setShowInfoBox(true);
      }, 4e3);
    }
    return () => clearTimeout(showInfoBoxTimeout.current);
  }, []);
  return /* @__PURE__ */ jsxs(StepContainer, { $wide: true, children: [
    /* @__PURE__ */ jsx(
      Waiting,
      {
        heading: hideWallets ? "Creating Your Account" : "Creating Your Wallet",
        subheading: "This should only take a couple of seconds."
      }
    ),
    showInfoBox && /* @__PURE__ */ jsx(CpslInfoBox, { children: /* @__PURE__ */ jsxs(InfoBoxContent, { children: [
      /* @__PURE__ */ jsxs(InfoBoxHeader, { children: [
        /* @__PURE__ */ jsx(CpslIcon, { icon: "clock" }),
        /* @__PURE__ */ jsx(CpslText, { weight: "medium", children: "Hang on" })
      ] }),
      /* @__PURE__ */ jsxs(CpslText, { variant: "bodyS", weight: "medium", color: "secondary", children: [
        "Creating your ",
        hideWallets ? "account" : "wallet",
        " is taking a little longer than expected, but we're working on it!"
      ] })
    ] }) })
  ] });
};
export {
  AwaitingWalletCreationStep
};
